import React, { useEffect, useReducer } from "react";
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
import { StateContext, DispatchContext } from "../store/context";
import initialState from "../store/state";
import Login from "../pages/Login";
import Signup from "../pages/Signup";
import ROUTES from "./routes";
import Dashboard from "../pages/Dashboard";
import Components from "../pages/Components";
import reducer from "../store/reducer";
import NotFound from "../pages/NotFound";
import ProtectedRoute from "./ProtectedRoute";
import StockListings from "../pages/StockListings";
import Stock from "../pages/Stock";
import CompareDashboard from "../pages/Compare";
import StockMarket from "../pages/StockMarket";
import Sector from "../pages/Sector";
import CompanyQuarter from "../pages/CompanyQuarter";
import MetricsManagement from "../pages/Metrics";
import UserManagement from "../pages/UserManagement";
import Roles from "../pages/UserManagement/Roles/Roles";
import Users from "../pages/UserManagement/Users/Users";
import TestPage from "../pages/TestPage";
import EquationBuilder from "../pages/Equation/EquationBuilder";
import RolePermissions from "../pages/UserManagement/Roles/RolePermissions";
import Entitlement from "../pages/UserManagement/Entitlements";
import NewRolePermissions from "../pages/UserManagement/Roles/NewRolePermissions";
import Landing from "../pages/Landing";
import Landing2 from "../pages/Landing2";
import Landing3 from "../pages/Landing3";
import DynamicGraphs from "../pages/DynamicGraphs";
import Settings from "../pages/Settings";
import Ads from "../pages/Ads";

import MetricsToAccountingTerm from "../pages/Settings/MetricsToAccountingTerms";
import Activation from "../pages/UserManagement/Users/Activation";
import GraphEditor from "../pages/GraphEditor";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import TechnicalAnalysis from "../pages/TechnicalAnalysis";
import CustomerProfile from "../pages/CustomerProfile";
import NewDynamicGraphs from "../pages/DynamicGraphs/newDynamicGraph";
import ScreenerPage from "../pages/screener";
import AiAnalyzeScreen from "../pages/aiscreen";
import Watchlist from "../pages/Watchlist";
import Support from "../pages/Support";
import Financials from "../pages/Financials";
import AnnualReportExtraction from "../pages/AnnualReportExtraction";
import AnnualReportManualEntry from "../pages/AnnualReportManualEntry";
import AnnualReportWorkflowHistory from "../pages/AnnualReportWorkflowHistory";
import AnnualReportQcQueue from "../pages/AnnualReportQcQueue";
import StockChatbot from "../pages/StockChatbot";
import StockAssistant from "../pages/StockAssistant";
import MarketHeatmap from "../pages/MarketHeatmap";
import FalconLogMonitor from "../pages/FalconLogMonitor";
import {
  loadFromSessionStorage,
  saveToSessionStorage,
} from "../utils/sessionStorageState";

import ManuallyCreatedUserUpdate from "../pages/ManuallyCreatedUserUpdate";
import SingleStockAnalysis from "../pages/SingleStockAnalysis";
import BeginnerScreen from "../pages/Beginner";

const AppRoutes: React.FC = (): React.ReactElement => {
  const [state, dispatch] = useReducer(
    reducer,
    loadFromSessionStorage() || initialState,
  );

  useEffect(() => {
    saveToSessionStorage({ ...state, error: null, alert: null });
  }, [state]);

  return (
    <DispatchContext.Provider value={dispatch}>
      <StateContext.Provider value={state}>
        <Router>
          <Routes>
            {/* <Route element={<Landing2 />} path={ROUTES.HOME} /> */}
            <Route element={<Login />} path={ROUTES.LOGIN} />
            <Route element={<Signup />} path={ROUTES.SIGNUP} />
            <Route element={<ForgotPassword />} path={ROUTES.FORGOT_PASSWORD} />
            <Route element={<ResetPassword />} path={ROUTES.RESET_PASSWORD} />
            <Route element={<Activation />} path={ROUTES.ACTIVATION} />

            {/* <Route
              element={<CompareDashboard />}
              path={ROUTES.CUSTOMER_DASHBOARD}
            /> */}
            {/* <Route element={<Components />} path={ROUTES.COMPONENTS} /> */}

            <Route element={<Dashboard />} path={ROUTES.HOME}>
              <Route element={<CompareDashboard />} path={ROUTES.OVERVIEW} />
              <Route element={<ScreenerPage />} path={ROUTES.SCREENER} />
              <Route element={<MarketHeatmap />} path={ROUTES.MARKET_HEATMAP} />
              <Route
                element={<TechnicalAnalysis />}
                path={ROUTES.TECHNICAL_ANALYSIS}
              />
              <Route element={<Financials />} path={ROUTES.FINANCIALS} />
              <Route
                element={<NewDynamicGraphs />}
                path={ROUTES.DYNAMIC_GRAPHS}
              />

              <Route element={<ProtectedRoute />}>
                <Route
                  element={<CustomerProfile />}
                  path={ROUTES.CUSTOMER_PROFILE}
                />
                <Route element={<Watchlist />} path={ROUTES.WATCHLIST} />
                <Route element={<AiAnalyzeScreen />} path={ROUTES.AI_ANALYZE} />
                <Route element={<StockChatbot />} path={ROUTES.STOCK_CHATBOT} />
                <Route
                  element={<StockAssistant />}
                  path={ROUTES.STOCK_ASSISTANT}
                />
                <Route element={<Support />} path={ROUTES.SUPPORT} />
                <Route
                  element={<SingleStockAnalysis />}
                  path={ROUTES.SINGLE_STOCK_ANALYSIS}
                />
                <Route element={<BeginnerScreen />} path={ROUTES.BEGINNER} />
                <Route
                  element={<AnnualReportWorkflowHistory />}
                  path={ROUTES.ANNUAL_REPORT_DATA_ENTRY}
                />
                <Route
                  element={<AnnualReportQcQueue />}
                  path={ROUTES.ANNUAL_REPORT_QC}
                />
                <Route
                  element={<AnnualReportExtraction />}
                  path={ROUTES.ANNUAL_REPORT_EXTRACTION}
                />
                <Route
                  element={<FalconLogMonitor />}
                  path={ROUTES.FALCON_LOG_MONITOR}
                />
                <Route
                  element={<AnnualReportManualEntry />}
                  path={ROUTES.ANNUAL_REPORT_MANUAL_ENTRY}
                />
                <Route element={<GraphEditor />} path={ROUTES.GRAPH_EDITOR} />
                {/* <Route element={<Revenues />} path={ROUTES.REVENUES} />
                                <Route element={<GrossProfits />} path={ROUTES.GROSS_PROFITS} />
                                <Route element={<NetProfits />} path={ROUTES.NET_PROFITS} />
                                <Route element={<PEValuations />} path={ROUTES.PE_VALUATIONS} /> */}
                <Route element={<StockMarket />} path={ROUTES.STOCK_MARKET} />
                <Route
                  element={<MetricsManagement />}
                  path={ROUTES.METRICS_MANAGEMENT}
                />
                <Route element={<Sector />} path={ROUTES.SECTOR} />
                <Route
                  element={<CompanyQuarter />}
                  path={ROUTES.COMPANY_QUARTER}
                />
                <Route
                  element={<StockListings />}
                  path={ROUTES.STOCK_LISTINGS}
                />
                <Route element={<Stock />} path={ROUTES.STOCKS} />
                <Route
                  element={<UserManagement />}
                  path={ROUTES.USER_MANAGEMENT}
                >
                  <Route element={<Users />} path={ROUTES.USERS} />
                  <Route element={<Roles />} path={ROUTES.ROLES} />
                  <Route element={<Entitlement />} path={ROUTES.ENTITLEMENTS} />
                </Route>
                <Route path={ROUTES.ROLES}>
                  <Route
                    element={<RolePermissions />}
                    path={ROUTES.ROLE_PERMISSIONS}
                  />
                  <Route
                    element={<NewRolePermissions />}
                    path={ROUTES.NEW_ROLE_PERMISSIONS}
                  />
                </Route>
                <Route
                  element={<EquationBuilder />}
                  path={ROUTES.EQUATION_BUILDER}
                />
                <Route element={<Ads />} path={ROUTES.ADS} />
                <Route element={<Settings />} path={ROUTES.SETTINGS}>
                  <Route
                    element={<MetricsToAccountingTerm />}
                    path={ROUTES.SETTINGS_METRICS_TO_ACCOUNTING_TERM}
                  />
                </Route>
              </Route>
            </Route>
            <Route
              element={<ManuallyCreatedUserUpdate />}
              path={ROUTES.MANUALLY_CREATED_USER_UPDATE}
            />
            <Route element={<TestPage />} path={"test-page"} />
            <Route element={<NotFound />} path="*" />
          </Routes>
        </Router>
      </StateContext.Provider>
    </DispatchContext.Provider>
  );
};

export default AppRoutes;
